import React from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'

import { Table, Tag, Card, Button, Descriptions } from 'antd'
import moment from 'moment'

import { GET_LOGS } from '../../graphql/queries'
import { GOOGLE_MAP_STATIC_URL } from '../../config'

const columns = [
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    render: action => <Tag color="green">{action}</Tag>
  },
  {
    title: 'Hero',
    dataIndex: 'hero.name',
    key: 'hero.name'
  },
  {
    title: 'Material',
    dataIndex: 'material.name',
    key: 'material.name'
  },
  {
    title: 'User',
    dataIndex: 'user.name',
    key: 'user.name'
  },
  {
    title: 'Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: date => moment(date).format('DD MMM YYYY')
  }
]

const MapStatic = ({ location }) => {
  const image = GOOGLE_MAP_STATIC_URL.replace(/{LOCATION}/g, location)

  return (
    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
      <img src={image} alt="user-location" />
    </div>
  )
}

MapStatic.propTypes = {
  location: PropTypes.string.isRequired
}

const Details = data => {
  return (
    <div>
      <MapStatic location={data.location} />

      <Descriptions>
        {data.material && (
          <Descriptions.Item label="วัสดุ">
            {data.material.name}
          </Descriptions.Item>
        )}

        {data.user && (
          <Descriptions.Item label="ผู้ใช้">{data.user.name}</Descriptions.Item>
        )}
        {data.hero && (
          <Descriptions.Item label="ฮีโร่">{data.hero.name}</Descriptions.Item>
        )}
        <Descriptions.Item label="ตำแหน่ง">{data.location}</Descriptions.Item>
        <Descriptions.Item label="วัน/เวลา">{data.createdAt}</Descriptions.Item>
        <Descriptions.Item label="ข้อมูลผู้ใช้">
          {data.userAgent}
        </Descriptions.Item>
        <Descriptions.Item label="Value String">
          {data.valueString}
        </Descriptions.Item>
        <Descriptions.Item label="Value Int">{data.valueInt}</Descriptions.Item>
      </Descriptions>
    </div>
  )
}

export const Logs = ({ data }) => {
  return (
    <Card
      title="Logs"
      extra={
        <Button size="small" icon="reload" onClick={() => data.refetch()}>
          Reload
        </Button>
      }
    >
      <Table
        rowKey={record => record.id}
        dataSource={data.logs}
        columns={columns}
        expandedRowRender={record => <Details {...record} />}
      />
    </Card>
  )
}

Logs.propTypes = {
  data: PropTypes.object.isRequired
}

export default compose(graphql(GET_LOGS))(Logs)



// WEBPACK FOOTER //
// ./src/pages/Logs/index.js